import { useContextKeycloak } from "@/app/module/keycloak/index";
import { clearProfileCacheByJwtTokenData } from "@/app/utils/profile-cache";
import {
  JwtTokenDataSchema,
  JwtTokenDataType,
  SystemViewUserItemSchema,
  SystemViewUserItemType,
} from "@/schemas/index";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";

export function useSystemView() {
  const { jwtToken } = useContextKeycloak();
  const [systemViewState, setSystemViewState] = useState<
    "init" | "disabled" | "enabled"
  >("init");
  const [jwtTokenData, setJwtTokenData] = useState<JwtTokenDataType>();
  const [delegateUserData, setDelegateUserData] =
    useState<SystemViewUserItemType>();

  const getKey = (jwtTokenData: JwtTokenDataType) =>
    `system-view-${jwtTokenData.session_state}`;

  const updateSystemView = (userId: string) => {
    axios.interceptors.request.use((config: any) => {
      config.headers["X-User-Id"] = userId;
      return config;
    });
  };

  const fetchCheckSystemView = () => {
    if (!jwtToken) {
      setSystemViewState("disabled");
      return;
    }

    let jwtTokenData: JwtTokenDataType;
    try {
      jwtTokenData = JwtTokenDataSchema.parse(jwtDecode(jwtToken));
    } catch (e) {
      setSystemViewState("disabled");
      console.warn(jwtToken);
      console.error(e);
      return;
    }

    const isEnabled = jwtTokenData?.["mapper-group-email"]?.includes("email-group");
    setJwtTokenData(jwtTokenData);

    if (isEnabled && localStorage.getItem(getKey(jwtTokenData))) {
      try {
        const delegateUserData = SystemViewUserItemSchema.parse(
          JSON.parse(localStorage.getItem(getKey(jwtTokenData))!),
        );

        setDelegateUserData(delegateUserData);
        updateSystemView(delegateUserData.Id);
      } catch (error) {
        console.error(error);
        localStorage.removeItem(getKey(jwtTokenData));
      }
    }

    setSystemViewState(isEnabled ? "enabled" : "disabled");
  };

  const fetchSaveSystemView = (delegateUserData: SystemViewUserItemType) => {
    localStorage.setItem(
      getKey(jwtTokenData!),
      JSON.stringify(delegateUserData),
    );
    clearProfileCacheByJwtTokenData(jwtTokenData!);
    window.location.pathname = `/home`;
  };

  const fetchResetSystemView = () => {
    localStorage.removeItem(getKey(jwtTokenData!));
    clearProfileCacheByJwtTokenData(jwtTokenData!);
    window.location.pathname = `/home`;
  };

  return {
    delegateUserData,
    systemViewState,
    fetchSaveSystemView,
    fetchResetSystemView,
    fetchCheckSystemView,
  };
}
